import { __ } from "@wordpress/i18n";
import Select from "../../../Common/Select"
import SbUtils from "../../../../Utils/SbUtils"

const ManageGdpr = ({ section, value, onChange }) => {
	const pluginActive = SbUtils.checkNotEmpty(section?.gdpr_plugins)
		? section?.gdpr_plugins
		: __('No GDPR plugin is active.');

    return (
        <div
			className='sb-settings-section-input'
			style={{
				width: '50%',
				display: 'flex',
				flexDirection: 'column',
				gap: '5px'
			}}
		>
            <Select
				size='medium'
				value={ value }
				onChange={(event) => {
					onChange(event.currentTarget.value)
				}}
			>
				{
					Object.keys(section?.options).map(optKey=> {
						const opt = section?.options[optKey]
						return (
							<option key={optKey} value={optKey}>{opt}</option>
						)
					})
				}
			</Select>
			<span
				style={{
					fontSize: '13px',
					color: '#444',
					display: 'block'
				}}
			>
				{
					(value === 'auto' || value === 'yes') &&
					pluginActive
				}
			</span>
        </div>
    )
}

export default ManageGdpr;